import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

import Error from 'bdvp-common/src/components/Error';
import NotFound from 'bdvp-common/src/components/NotFound';
import { SEARCH_ROUTE, GAME_STATUS } from 'bdvp-common/src/utils/constants';
import { useIsEU } from 'bdvp-common/src/hooks/store';

import useGameData from '../hooks/useGameData';
import GameIndexPageComponent from '../components/GameIndexPage';

const GameIndexPage = () => {

    const {
        loading,
        data,
        error,
    } = useGameData();

    const { gamePk } = useParams();
    const { isEU } = useIsEU();
    const isPlaybackReady = typeof isEU !== 'undefined';

    if (error) {

        return <Error />;

    }

    if (!loading && !data) {

        return <NotFound />;

    }

    if (!loading && data?.status !== GAME_STATUS.final) {

        return (
            <Redirect
                to={{
                    pathname: SEARCH_ROUTE,
                    search: `?q=${encodeURIComponent(`ContentTags = ["gamepk-${gamePk}"] Order by Timestamp DESC`)}`,
                }}
            />
        );

    }

    return (
        <GameIndexPageComponent
            loading={loading}
            data={data}
            isEU={isEU}
            isPlaybackReady={isPlaybackReady}
        />
    );

};

export default GameIndexPage;
